import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { fetchPosterList } from '@/api/website/creative';

export default {
  name: 'PosterSelector',

  componentName: 'PosterSelector',

  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      remoteLoading: false,
      baseOptions: []
    };
  },


  computed: {
    innerConfig: function innerConfig() {
      var params = _extends({
        placeholder: '请选择发布者'
      }, this.config.params);
      return _extends({}, this.config, {
        params: params
      });
    },
    formItemStyle: function formItemStyle() {
      var style = this.innerConfig.params.style || {};
      if (this.innerConfig.params.width) {
        style.width = this.innerConfig.params.width;
        if (typeof style.width === 'number') {
          style.width += 'px';
        }
      }
      return style;
    }
  },

  methods: {
    querySearchAsync: function querySearchAsync(queryString, cb) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fetchPosterList({
                  name: queryString
                });

              case 3:
                res = _context.sent;

                cb(_.get(res, 'data.data.list', []));
                _context.next = 9;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    },
    handleSelect: function handleSelect(item) {
      this.formValue[this.innerConfig.prop] = item.name;
      this.config.params.selectCallback(item);
    },
    remoteBase: function remoteBase(query) {
      var _this2 = this;

      this.remoteLoading = true;
      fetchPosterList({
        page: 1,
        name: query
      }).then(function (res) {
        _this2.remoteLoading = false;
        _this2.baseOptions = res.data.data.list;
      }).catch(function () {
        _this2.baseOptions = [];
        _this2.remoteLoading = false;
      });
    }
  },

  mounted: function mounted() {
    // if (this.baseOptions && !this.baseOptions.length) {
    //   this.remoteBase(this.formValue[this.innerConfig.prop])
    // }
  }
};